<script lang="ts">
	import { Dialog as DialogPrimitive } from "bits-ui";
	import { cn } from "$lib/utils.js";
	import { getModalPresentation, modalPresentationStyle } from "$lib/overlays/modal-coordinator.svelte";

	let {
		ref = $bindable(null),
		class: className,
		style,
		...restProps
	}: DialogPrimitive.OverlayProps = $props();
	const modal = getModalPresentation();
</script>

<DialogPrimitive.Overlay
	bind:ref
	data-slot="dialog-overlay"
	class={cn(
		"data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 fixed inset-0 z-50 bg-black/50",
		className
	)}
	{...restProps}
	style={modalPresentationStyle(modal, style)}
/>
